import { useSession } from "@packages/core-client/session/SessionContext.tsx";
import type { Session } from "@packages/core/session/session.ts";
import { useFeatureFlags } from "@squide/firefly";

export const ALLOWED_WL_MEMBER_IDS: ReadonlySet<string> = new Set([
    "00000000-0000-0000-0000-000000000000",
    "b86c929b-08c0-41df-9ae5-d19645fa1b2f",
    "0007960d-e3a8-4e4f-9d2c-e5df596cd710",
    "54377c4f-a1d6-41fa-b95f-b65a2918f543",
    "06bb51c8-e7c2-4a14-a716-d4e591b9f2af",
    "6d8807c8-0bf5-4e2f-836c-87569cd3efbc",
    "81045fd5-e65f-4d05-8a75-54672f10ab6c",
    "e0a2be4c-7e53-4ddf-9676-af30101fba78",
    "7c34a746-0e2c-4e45-a4ae-705c5585df7e",
    "05d467da-5f34-4b09-a157-3d31379936f5"
]);

function isAllowedWlMember(session: Session | null | undefined) {
    return !!session?.memberId && ALLOWED_WL_MEMBER_IDS.has(session.memberId.toLowerCase());
}

export function isMeetingsInPerformanceEnabled(isFeatureFlagEnabled: boolean, session: Session | null | undefined) {
    return isFeatureFlagEnabled || isAllowedWlMember(session);
}

export function useIsMeetingsInPerformanceEnabled() {
    const isFeatureFlagEnabled = useFeatureFlags()["meetings-in-performance"];
    const session = useSession();

    return isMeetingsInPerformanceEnabled(isFeatureFlagEnabled, session);
}
